import { Button, Stack, Typography } from '@mui/material';
const Pagination = ({ page = 1, limit = 50, total = 0, onPageChange, loading = false }) => {
  const totalPages = Math.max(1, Math.ceil(total / limit));
  if (totalPages <= 1) return null;
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
      }}
    >
      <Button
        size="small"
        disabled={loading || page <= 1}
        onClick={() => onPageChange(page - 1)}
        variant="text"
      >
        הקודם
      </Button>

      <Stack direction="row" sx={{ alignItems: 'center', mx: 1, gap: 0.5 }}>
        <Typography sx={{ fontSize: 12 }}>{page}</Typography>
        <Typography sx={{ fontSize: 12 }}>מתוך</Typography>
        <Typography sx={{ fontSize: 12 }}>{totalPages}</Typography>
      </Stack>

      <Button
        size="small"
        variant="text"
        disabled={loading || page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        הבא
      </Button>
    </Stack>
  );
};
export default Pagination;
